<template>
  <v-menu offset-y left nudge-bottom="14" min-width="230" content-class="user-profile-menu-content">
    <template v-slot:activator="{ on, attrs }">
      <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
        <v-avatar size="40px" v-bind="attrs" v-on="on">
          <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
        </v-avatar>
      </v-badge>
    </template>

    <v-list>
      <div class="pb-3 pt-2">
        <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
          <v-avatar size="40px">
            <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
          </v-avatar>
        </v-badge>
        <div class="d-inline-flex flex-column justify-center ms-3">
          <span class="text--primary font-weight-semibold mb-n1">
            Hello <b>{{ $store.state.username }}</b>
          </span>
          <small class="text--disabled text-capitalize">Manager</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Notifications -->
      <v-list-item link @click.stop="toggleNotificationDialog">
        <v-list-item-icon class="me-2">
          <v-icon size="22">{{ icons.mdiBellOutline }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ notificationEnabled ? 'Disable Notifications' : 'Enable Notifications' }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Profile -->
      <v-list-item link :to="{ name: 'profile-account-settings' }">
        <v-list-item-icon class="me-2">
          <v-icon>{{ icons.mdiAccountOutline }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Logout -->
      <v-list-item link @click="logOut()">
        <v-list-item-icon class="me-2">
          <v-icon size="22">{{ icons.mdiLogoutVariant }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- Dialog for notification permission -->
    <v-dialog v-model="dialog" max-width="450" persistent @input="onDialogChange">
      <v-card class="notification-dialog">
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">{{ icons.mdiBellOutline }}</v-icon>
          {{ notificationEnabled ? 'Disable Notifications' : 'Enable Notifications' }}
        </v-card-title>
        
        <v-card-text class="pt-4 pb-2">
          <div v-if="!notificationEnabled" class="text-body-1">
            <p class="mb-3">
              <v-icon color="info" class="me-2">mdi-information</v-icon>
              Would you like to enable push notifications to receive important alerts and updates?
            </p>
            <p class="text--secondary text-body-2 mb-0">
              You can disable this feature at any time from this menu.
            </p>
          </div>
          
          <div v-else class="text-body-1">
            <p class="mb-3">
              <v-icon color="success" class="me-2">mdi-check-circle</v-icon>
              Notifications are currently enabled. You will receive important alerts and updates.
            </p>
            <p class="text--secondary text-body-2 mb-0">
              Are you sure you want to disable push notifications?
            </p>
          </div>
        </v-card-text>
        
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn 
            text 
            color="grey darken-1" 
            @click="closeDialog"
            class="me-2"
          >
            Cancel
          </v-btn>
          <v-btn 
            v-if="!notificationEnabled"
            depressed
            color="primary" 
            @click="requestPermission"
            :loading="loading"
          >
            <v-icon left>mdi-bell</v-icon>
            Enable
          </v-btn>
          <v-btn 
            v-else
            depressed
            color="error" 
            @click="disableNotifications"
            :loading="loading"
          >
            <v-icon left>mdi-bell-off</v-icon>
            Disable
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-menu>
</template>

<script>
import axios from 'axios'
import firebase from "firebase/app"
import "firebase/messaging"
import {
  mdiAccountOutline,
  mdiLogoutVariant,
  mdiBellOutline,
} from '@mdi/js'

// ✅ Config Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBmiKnNODZBTqZgf1SSqrxABLclN-km27U",
  authDomain: "pettycash-manager.firebaseapp.com",
  projectId: "pettycash-manager",
  storageBucket: "pettycash-manager.appspot.com",
  messagingSenderId: "807836467697",
  appId: "1:807836467697:web:abb2634393d92748848450",
  measurementId: "G-PDTT2EW924"
}
const vapidKey = "BCjM1TLmxO58ah3k8ndBgJqVsNS_qPgsESS5rMpLN7nlEuFjmhf-cSEDHT86FJhuEFIwse8ePq1-SWgPQGsdfY4"

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}
const messaging = firebase.messaging()

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      notificationEnabled: false,
      icons: { 
        mdiAccountOutline, 
        mdiLogoutVariant, 
        mdiBellOutline 
      },
    }
  },

  mounted() {
    this.checkNotificationStatus()
  },

  methods: {
    onDialogChange(value) {
      this.dialog = value
    },

    toggleNotificationDialog() {
      console.log("Opening dialog...") // Debug
      // Petit délai pour permettre au menu de se fermer d'abord
      this.$nextTick(() => {
        setTimeout(() => {
          this.dialog = true
        }, 100)
      })
    },

    closeDialog() {
      this.dialog = false
    },

    async checkNotificationStatus() {
      try {
        const permission = Notification.permission
        this.notificationEnabled = permission === 'granted'
      } catch (err) {
        console.error("Error checking notification status:", err)
        this.notificationEnabled = false
      }
    },

    async requestPermission() {
      this.loading = true
      try {
        // Request permission first
        const permission = await Notification.requestPermission()
        
        if (permission === 'granted') {
          const currentToken = await messaging.getToken({ vapidKey })
          
          if (currentToken) {
            console.log("🔔 Token obtained:", currentToken)
            
            await axios.post("/api/v1/manager/save-token/", {
              token: currentToken,
              device_type: "web",
            }, {
              headers: { Authorization: "Token " + this.$store.state.token }
            })
            
            this.notificationEnabled = true
            this.closeDialog()
            
            this.$store.commit('setSnackBarMessage', "Notifications enabled successfully ✅")
            this.$store.commit('setSnackBarColor', "green darken-2")
            this.$store.commit('activateSnackBar', true)
          } else {
            throw new Error('No registration token available')
          }
        } else {
          throw new Error('Notification permission denied')
        }
      } catch (err) {
        console.error("❌ Error enabling notifications:", err)
        this.closeDialog()
        this.$store.commit('setSnackBarMessage', "Failed to enable notifications ❌")
        this.$store.commit('setSnackBarColor', "red darken-2")
        this.$store.commit('activateSnackBar', true)
      }
      this.loading = false
    },

    async disableNotifications() {
      this.loading = true
      try {
        // Call API to remove token from server
        await axios.post("/api/v1/manager/remove-token/", {
          device_type: "web",
        }, {
          headers: { Authorization: "Token " + this.$store.state.token }
        })
        
        this.notificationEnabled = false
        this.closeDialog()
        
        this.$store.commit('setSnackBarMessage', "Notifications disabled successfully")
        this.$store.commit('setSnackBarColor', "orange darken-2")
        this.$store.commit('activateSnackBar', true)
        
      } catch (err) {
        console.error("❌ Error disabling notifications:", err)
        this.closeDialog()
        this.$store.commit('setSnackBarMessage', "Failed to disable notifications ❌")
        this.$store.commit('setSnackBarColor', "red darken-2")
        this.$store.commit('activateSnackBar', true)
      }
      this.loading = false
    },

    logOut() {
      axios.defaults.headers.common['Authorization'] = ""
      localStorage.clear()
      this.$store.commit('removeToken')
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}

.notification-dialog {
  .v-card__title {
    padding: 16px 24px;
    border-radius: 4px 4px 0 0;
  }
  
  .v-card__text {
    line-height: 1.6;
  }
  
  .v-btn {
    text-transform: none;
    font-weight: 500;
  }
}
</style>